module.exports = __webpack_public_path__ + "assets/f90501fb8ab06a4fd450a37d921d16fc.jpg";